module.exports = __webpack_public_path__ + "static/media/logo-wm.5d0b9fc7.png";